module.exports = __webpack_public_path__ + "4713bc50cec03dfaf63178c306e33993.gif";